export default "__VITE_ASSET__a72b7714__"